import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '@s2a/core';

import { AppShellApplications } from '../config/application.config';
import { SessionService } from '../services/session.service';
import { S2A_LAST_USED_APP } from '../constants/storage.constant';
import { CookieService } from '../services/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class AuthoriseGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private sessionService: SessionService,
    private authService: AuthService
  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (this.authService.hasToken) {

      // Enabling all application
      const apps = ['welcome', 'drinktec-welcome'];
      AppShellApplications.forEach((app) => {
        apps.push(app.key);
      });

      if (route.data.appUrl && apps.indexOf(route.data.appUrl) === -1) {
        this.router.navigate(['/forbidden']);
        return false;
      } else {
        this.cookieService.set('s2a-last-used-app', route.data.appUrl, 30, '/');
      }

      return true;

    }
    return true;
  }
}
